import React, { Component } from "react";
import { createRoot } from "react-dom/client";
import Channels from "../components/Channels/Channels";
import "../../sass/_document.scss";
import Grid from "../components/Grid/Grid";
import Footer from "../components/Footer/Footer";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import ConfigurationHelper from "../configuration/ClientConfigurationHelper";
import theme from "../../sass/variables.json";
import TopAmbassadors from "../components/TopAmbassadors/TopAmbassadors";
import { StoreProvider } from "../contexts/store";

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shouldRenderBelow: true,
        };
    }

    componentDidMount() {
        this.checkUrlParams();
    }

    checkUrlParams = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const channelId = parseInt(urlParams.get('channelId'), 10) || 0;

        if (channelId > 0) {
            this.setState({ shouldRenderBelow: false });
        }
    };

    handleFlagChange = (flagValue) => {
        this.setState(() => {
            return { shouldRenderBelow: flagValue };
        });
    };

    render() {
        const { shouldRenderBelow } = this.state;
        const channelApiUrl = `${ConfigurationHelper.getGlobalConfiguration().apiUrl}channels/${ConfigurationHelper.getLatestVideosChannelId()}/contents`;
        return (
            <div data-testid="homepage" className={"document-body " + theme.hub_wrapper_css_class}>
                <Channels onFlagChange={this.handleFlagChange} />
                {shouldRenderBelow && (
                    <>
                        <Breadcrumbs keepOnMobile />
                        {ConfigurationHelper.isAmbassadorProgramEnabled() ? <TopAmbassadors /> : null}
                        <div className={"container"}>
                            <div className={"row"}>
                                <h2 className={"col-12 text-center tvp-latest-post-title"}>RECENTLY POSTED</h2>
                            </div>
                        </div>
                        <Grid gridTitle={" "} baseApiUrl={channelApiUrl} />
                        {ConfigurationHelper.enableHeaderFooter() && <Footer />}
                    </>
                )}
            </div>
        );
    }
}

export default Home;

const targetEl = document.getElementById("app-container");

if (targetEl) {
    const root = createRoot(targetEl);
    root.render(<StoreProvider><Home /></StoreProvider>);
}
